import '@/lib/sockjs'
import '@/lib/stomp'
import {fzk_socket_url} from '@/api/uri/socket.js'
import StorageHelp from '@/utils/storageHelp'
let isClose = false;
let connectCount = 1;
export const stompSocket = {
  namespaced: true,
  state:{
    //  stomp: Stomp.over(new SockJS("/ws/endpointChat"))
    //  websockket  连接
    stomp: null,

    socketFlag: true,
    timer: null,
  },
  mutations: {

  },
  actions: {
    //websocket订阅
    connect(context,str){
      // let headers  = {}
      // return new Promise((resolve,reject)=>{
      //   //获取 STOMP 子协议的客户端对象
      //   console.log("fzk_socket_url.webSocket",fzk_socket_url.webSocket)
      //   let sockJs = new SockJS(fzk_socket_url.webSocket,'',{
      //     timeout: 8000
      //   });
      //   context.state.stomp = Stomp.over(sockJs);
      //
      //   //向服务器发起websocket连接并发送CONNECT帧
      //   context.state.stomp.connect(headers, frame=> {
      //     console.log('链接我成功了吗？？？？？');
      //
      //     //todo  连接成功删除定时器
      //     clearInterval(context.state.timer);
      //     // 连接成功时（服务器响应 CONNECTED 帧）的回调方法
      //     //STOMP 客户端要想接收来自服务器推送的消息，必须先订阅相应的URL，即发送一个 SUBSCRIBE 帧，然后才能不断接收来自服务器的推送消息；
      //     //  var subscription = client.subscribe(...); 取消订阅subscription.unsubscribe();
      //     context.dispatch('socketSplit',{
      //       stomp: context.state.stomp,
      //       resolve:resolve
      //     })
      //     //关闭stomp日志
      //     context.state.stomp.debug = null;
      //
      //   },failedMsg=> {
      //     console.log("websocket,链接失败");
      //
      //     context.state.stomp.disconnect(() => {
      //       console.log("websocket,终止链接")
      //       console.log(sockJs,"关闭socket")
      //       sockJs.onclose = (e) => {
      //         // 已经关闭的情况，不重连
      //         if (isClose) {
      //           return;
      //         }
      //         sockJs.close();
      //         console.log('onclose,关闭请求',e)
      //       }
      //       // todo 链接失败，2秒重新连接
      //       console.log("????",context.state.timer)
      //       context.state.timer = setTimeout(()=> {
      //         console.log("????");
      //         context.dispatch("connect");
      //       },10000)
      //       // console.log(socketJs)
      //     })
      //   });
      // });
    },
    // 订阅消息
    socketSplit(context,{resolve}) {
      console.log('接收订阅前')
      let headers  = {};
      let stomp = context.state.stomp
      if(stomp){   // 订阅版本更新通知
        stomp.subscribe(fzk_socket_url.versionApi, message=> {
          console.log('版本更新通知',message)
          handleSubscribe(message);
          //通知服务器，已经收到消息
          message.ack();
          resolve(true)
        },headers);
        // 订阅内容更新通知
        stomp.subscribe(fzk_socket_url.contentManageChange, message=> {
          console.log('内容更新',message);
          handleSubscribe(message);
          //通知服务器，已经收到消息
          message.ack();
          resolve(true)
        },headers);

      }
      function handleSubscribe(message) {
        if(message){
          // todo  版本更新， 刷新页面
        /*  if(message.headers.destination === fzk_socket_url.versionApi) {
            let version = JSON.parse(message.body).version
            if(version){
              // 判断当前本地版本是否等于服务器版本，等于的话就不做更新处理
              if(StorageHelp.getStorage(StorageHelp.VERSION) != version) {
                StorageHelp.setStorage(StorageHelp.VERSION,version)
                console.log('执行刷新了')
                window.location.reload()
              }
            }
          }*/

          // todo  内容更新刷新页面
          if(message.headers.destination === fzk_socket_url.contentManageChange) {
            // window.location.reload();
          }

        }
      }
    },
    // 关闭socket
    closeSocket (context) {
      console.log('关闭websocket',context.state.stomp)
      context.state.stomp.disconnect(function() {
        console.log('关闭连结')
      })
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/stompSocket.js